import React, { useEffect, useRef, useState } from "react";
import GoogleMapReact from 'google-map-react';
import { LocationMarkerIcon } from '@heroicons/react/solid'
import ReactDOM from 'react-dom';

// import SearchBox from './google-map.searchbox'

const AnyReactComponent = () => (
  <LocationMarkerIcon className="w-8 h-8 text-primary-400 " style={{ transform: 'translate(-50%, -100%)' }} />
)

export default function GoogleMap({ lat, lng, onUpdate, handlePlacesChanged, placeDefaultValue }) {
  const [mapState, setMapState] = useState({
    draggable: true,
    center: [lat || 13.7244416, lng || 100.3529157],
    lat: lat || 13.7244416,
    lng: lng || 100.3529157,
    zoom: 13
  })

  const [mapApi, setMapApi] = useState({ isLoaded: false, instance: null, maps: null })

  const apiLoaded = (map, maps) => {
    setMapApi({
      isLoaded: true,
      instance: map,
      maps: maps,
    });
  }

  const onPlacesChanged = (place) => {
    if (place) {
      const lat = place.geometry.location.lat()
      const lng = place.geometry.location.lng()
      setMapState(prev => ({ ...prev, center: [lat, lng], lat, lng }))
    }

    handlePlacesChanged(place)
  }

  const onChildMouseDown = (childKey, childProps, mouse) => {
    // console.log('onChildMouseDown', mouse)

    // set map no draggable 
    setMapState(prev => ({ ...prev, draggable: false }))
  }

  const onChildMouseMove = (childKey, childProps, mouse) => {
    setMapState(prev => ({ ...prev, draggable: false, lat: mouse.lat, lng: mouse.lng }))
  }

  const onChildMouseUp = (childKey, childProps, mouse) => {
    onUpdate(mapState)
    // function is just a stub to test callbacks  
    setMapState(prev => ({ ...prev, draggable: true }))

  }
  // console.log(mapApi)
  return (
    // Important! Always set the container height explicitly
    <>

      {/* {mapApi.isLoaded && <SearchBox map={mapApi.instance} mapsapi={mapApi.maps} />} */}

      {mapApi.isLoaded && <SearchBox mapsapi={mapApi.maps} onPlacesChanged={onPlacesChanged} defaultValue={placeDefaultValue} />}
      <div className="w-full mt-3 overflow-hidden h-[480px]">
        <GoogleMapReact
          center={mapState.center}
          defaultZoom={mapState.zoom}

          className="h-full"
          bootstrapURLKeys={{
            key: "AIzaSyCrr0fYPsWmzVMBDkmJMqDuy6jHXr6VzPE",
            // region: 'th',
            libraries: ['places', 'drawing', 'geometry'],
          }}
          draggable={mapState.draggable}
          // onDrag={((map) => console.log(map))}
          // onDragEnd={((map) => console.log(map))}
          onChildMouseDown={onChildMouseDown}
          onChildMouseMove={onChildMouseMove}
          onChildMouseUp={onChildMouseUp}
          onGoogleApiLoaded={({ map, maps }) => {
            apiLoaded(map, maps);
          }}
        >

          <AnyReactComponent
            lat={mapState.lat}
            lng={mapState.lng}

            text="My Marker"
          />
        </GoogleMapReact>
      </div>
    </>
  );
}


const SearchBox = (props) => {
  const inputRef = useRef(null)
  let searchBox = useRef(null)

  const onPlacesChanged = () => {
    console.log(searchBox.getPlace())
    props.onPlacesChanged(searchBox.getPlace());
  }

  useEffect(() => {
    const input = ReactDOM.findDOMNode(inputRef.current);
    const { places, event } = props.mapsapi
    const options = {
      componentRestrictions: { country: 'th' }
    };
    searchBox = new  places.Autocomplete(input, options);
    // searchBox = new places.SearchBox(input, options);

    searchBox.addListener('place_changed', onPlacesChanged);
    return () => {
      event?.clearInstanceListeners(searchBox.current);
    }
  }, [])


  return (
    <div className="grid grid-cols-12 gap-6">
      <div className="col-span-6">
        <input ref={inputRef} defaultValue={props.defaultValue}
          type="text"
          className="block w-full mb-1 border-gray-300 rounded-md shadow-sm focus:ring-0 focus:border-gray-300 sm:text-sm" />
      </div>
    </div>
  )
}